import { useEffect } from 'react';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { shouldJitterAnonymousTimestamp } from '@/lib/analytics/anonymous/jitter';
import { buildAnonymousAnalyticsEvent } from '@/lib/analytics/anonymous/policy';
import { emitAnonymousGrowthBookEvent } from '@/lib/analytics/growthbook/ingestion';
import logger from '@/lib/analytics/growthbook/logger';
import { getConsent } from '@/lib/consent';
import { addAnalyticsEventListener } from '../utils/analyticsEventBus';

export const useGrowthBookEventsTracking = () => {
  const growthbook = useGrowthBook();

  useEffect(() => {
    const listener = (eventName: string, properties: Record<string, unknown>) => {
      const consent = getConsent();

      // Session trackingCallback owns experiment_viewed (plugin or anonymous ingest).
      if (eventName === 'experiment_viewed') {
        return;
      }

      try {
        if (!growthbook) return;

        if (!consent.allowed) {
          const anonymousEvent = buildAnonymousAnalyticsEvent(eventName, properties);
          if (!anonymousEvent) {
            return;
          }

          emitAnonymousGrowthBookEvent(
            growthbook,
            anonymousEvent.eventName,
            anonymousEvent.properties,
            shouldJitterAnonymousTimestamp(eventName, anonymousEvent.properties)
          );
          return;
        }

        growthbook.logEvent(eventName, properties).catch((error) => {
          logger.error('Error forwarding event to GrowthBook', error);
        });
      } catch (error) {
        logger.error('Error forwarding event to GrowthBook', error);
      }
    };

    return addAnalyticsEventListener(listener);
  }, [growthbook]);
};
